
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './lib/toast';
import { useThemeStore } from './stores/theme.store';
import './index.css';

// L'aspetto si applica qui, prima di disegnare qualunque cosa.
//
// Finora ci arrivava per caso: il menu di sinistra importava lo store del
// tema, quindi il modulo veniva caricato con la schermata e la preferenza
// salvata veniva riapplicata da sola. Spostate le scelte in Profilo → Aspetto,
// l'unico importatore è diventato una pagina caricata su richiesta: chi apriva
// il prodotto su una qualunque altra pagina vedeva «Classico» anche avendo
// scelto altro — la preferenza era salva, semplicemente non la leggeva
// nessuno. Una dipendenza implicita da dove sta un pulsante: ora è esplicita.
useThemeStore.getState().init();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);
